import { SettingsSectionId } from './types';

type AccountSection = 'account';
type NotificationSection = 'notifications';
type SecuritySection = 'security';
type SupportSection = 'support';
type StepCountSection = 'steps';
type TermsAndAgreementsSection = 'terms';

export function isAccountSettings(sectionId: SettingsSectionId): sectionId is AccountSection {
  return sectionId === 'account';
}

export function isNotificationSettings(
  sectionId: SettingsSectionId,
): sectionId is NotificationSection {
  return sectionId === 'notifications';
}

export function isSecuritySettings(sectionId: SettingsSectionId): sectionId is SecuritySection {
  return sectionId === 'security';
}

export function isSupportSettings(sectionId: SettingsSectionId): sectionId is SupportSection {
  return sectionId === 'support';
}

export function isStepCountSettings(sectionId: SettingsSectionId): sectionId is StepCountSection {
  return sectionId === 'steps';
}

export function isTermsAndAgreements(
  sectionId: SettingsSectionId,
): sectionId is TermsAndAgreementsSection {
  return sectionId === 'terms';
}
